import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import { useTranslation } from "react-i18next";

import { useMediaQuery } from "context/media/MediaContext";
import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { TokenInclude } from "helpers/GetToken";

import { FaqDetailsAsync } from "services/employeeProfile.service";
import { setServiceError } from "redux/slices/ServiceInlineError";

import { Button, Image, Spinner, Typography } from "components";
import Alert from "components/BaseComponents/Alert/Alert";
import { Col, ElementWrapper, Row } from "components/BaseComponents/Flex";
import { IFaqDetailsResponse } from "models/Employee/employeeProfile.model";

const FaqDetails: FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useMediaQuery();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState<boolean>(false);
  const [faqDetailsData, setFaqDetailsData] = useState<IFaqDetailsResponse>();

  const [isAddSuccess, setIsAddSuccess] = useState<boolean>(false);
  const [isAddError, setIsAddError] = useState<boolean>(false);
  const [txt, setTxt] = useState<string>("");
  const params = useParams<string>();

  const token = TokenInclude();
  const { faqId } = params;

  useEffect(() => {
    async function runFaqDetails() {
      setLoading(true);
      const retVal = await FaqDetailsAsync(token, faqId!);
      if (retVal?.DialogBoxes?.length < 1) {
        setFaqDetailsData(retVal);
        setLoading(false);
      } else {
        const errMessage: any = retVal;
        setLoading(false);
        dispatch(setServiceError(errMessage));
        return;
      }
    }
    runFaqDetails();
  }, [faqId]);

  return (
    <>
      <ElementWrapper
        width='872px'
        height={`${isMobile ? "calc(100vh + 355px)" : "100vw"}`}
        direction='column'
        justifyContent='flex-start'
        alignItems='flex-start'
        margin='10px auto 51px'
        padding={`${isMobile ? "0 5px !important" : ""}`}
      >
        <Spinner show={loading} />
        {isAddError && (
          <Alert
            alertType='Error'
            duration={9000}
            isVisible={isAddError}
            message={txt}
            setIsAddSuccess={setIsAddSuccess}
            setIsAddError={setIsAddError}
          />
        )}

        <Row
          width='100%'
          backgroundColor={DIGIPOSTHEME.colors.transparent}
          justifyContent='center'
        >
          <Image
            margin={isMobile ? "0" : "20px 0 0 0"}
            alt='Frequently Asked Questions'
            height='500px'
            srcSet={faqDetailsData?.ImageUrl}
            width='100%'
            borderRadius='5px'
          />
        </Row>

        <Row
          padding='25px 0 0 0'
          backgroundColor={DIGIPOSTHEME.colors.transparent}
          width='100%'
        >
          <Typography
            size='15px'
            color={DIGIPOSTHEME.colors.secondaryGraySecondary}
            transform='uppercase'
          >
            {t("question_page_title")}
          </Typography>
        </Row>

        <Row backgroundColor={DIGIPOSTHEME.colors.transparent}>
          <Typography
            size='20px'
            color={DIGIPOSTHEME.colors.darkGrey}
            transform='capitalize'
            margin='0 0 20px 0'
            display='flex'
          >
            {faqDetailsData?.Title}
          </Typography>

          <Typography
            size='15px'
            color={DIGIPOSTHEME.colors.darkGrey}
            display='flex'
          >
            {faqDetailsData?.Description}
          </Typography>
        </Row>

        <Row
          backgroundColor={DIGIPOSTHEME.colors.secondaryOffWhite}
          justifyContent='space-between'
          isResponsive
          noMargin
        >
          <Col margin={isMobile ? "90px 0 20px 0" : "10px auto"}>
            <Button
              type='button'
              width={isMobile ? "100%" : "100px"}
              text={`← ${t("back")}`}
              onClick={() => navigate(-1)}
              color='light'
            />
          </Col>
        </Row>
      </ElementWrapper>
    </>
  );
};

export default FaqDetails;
